import { CSSProperties } from "react";
import { ColumnPinningPosition } from "@tanstack/react-table";
import { createTableStyle, TableStyles_Types } from "../../../Definitions";

export const LEFT_FROZEN_TABLE_WIDTH = 120;
export const RIGHT_FROZEN_TABLE_WIDTH = 100;

export const getRemoveRowActionStyle = ( id: string ): CSSProperties | undefined => {
  if (id === "removeRowActionColumn") {
    return { minWidth: "40px", maxWidth: "40px", padding: "0px 8px" };
  }
};

export const getFrozenColumnStyle = (
  isPinned: ColumnPinningPosition, isLastColumn: boolean, isFirstColumn: boolean, cellIndex: number, rowLength: number, isHeader: boolean = false, tableType: TableStyles_Types, pinnedWidthOffset: number ): CSSProperties | undefined => {
  const { pinningBorderStyle } = createTableStyle(tableType);
  const borderValue = pinningBorderStyle.border;

  if (isPinned) {
    return {
      zIndex: isPinned ? 999 + +isHeader : 1 + +isHeader,
      position: isPinned ? "sticky" : "relative",
      left: isPinned === "left" ? `${pinnedWidthOffset}px` : "auto",
      right: isPinned === "right" ? `${pinnedWidthOffset}px` : "auto",
      borderRight: isLastColumn ? borderValue : "none",
      borderLeft: isFirstColumn ? borderValue : "none",
      minWidth: "auto",
    };
  }
};

export const convertPxValueToNumber = (pxValue: string) => {
  return Number(pxValue.split("px")[0]);
};

export const pinnedWidthOffset = (isPinned: ColumnPinningPosition, columnWidthNumberValue: number[], columnIndex: number) => {
  if (!isPinned) {
    return 0;
  }

  if (isPinned === "left") {
    return columnWidthNumberValue.slice(0, columnIndex).reduce((accumulator, value) => {return accumulator + value}, 0);
  }

  return columnWidthNumberValue.slice(columnIndex + 1).reduce((accumulator, value) => {return accumulator + value}, 0);
};

export const getWidthIfPinned = (pinned: ColumnPinningPosition, width?: string) => {
  if (pinned === "left") {
    return width ? width +" " : `${LEFT_FROZEN_TABLE_WIDTH}px `;
  }
  if (pinned === "right") {
    return width ? width +" " : `${RIGHT_FROZEN_TABLE_WIDTH}px `;
  }
  return width ? width +" " : "1fr ";
};
